import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { formsApi } from '../services/formsApi';
import type { FormSubmissionQuery } from '@troia-v3/types';
import { toast } from 'sonner';

export const useFormResponses = (formId?: string, query?: Partial<FormSubmissionQuery>) => {
  return useQuery({
    queryKey: ['form-responses', formId, query],
    queryFn: () => formsApi.getResponses(formId!, query),
    enabled: !!formId,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useDeleteFormResponse = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ formId, responseId }: { formId: string; responseId: string }) =>
      formsApi.deleteResponse(formId, responseId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['form-responses', variables.formId] });
      queryClient.invalidateQueries({ queryKey: ['form-stats', variables.formId] });
      toast.success('Resposta excluída com sucesso!');
    },
    onError: () => {
      toast.error('Erro ao excluir resposta');
    },
  });
};
